import React, { useEffect, useState } from 'react'
import NFTButton from '../../newComponents/NFTButton'
import INFTUpload from './INFTUpload'
import { InputWrapper, InputError, InputLabel, InputUpload } from './styled'

export default function NFTUpload(props: INFTUpload) {
  const { errorMessage, id, name, label, description, setFieldValue, accept, value, validate, removeFile } = props
  const [filePreviewItem, setFilePreviewItem] = useState(<React.Fragment />)
  useEffect(() => {
    let previewItem
    const fileType = value ? value.file.type.split('/')[0] : 'image'
    const src = value ? URL.createObjectURL(value.file) : ''
    if (fileType === 'video') {
      previewItem = (
        <video key={name + 'file-video-preview'} controls={true} muted={true} autoPlay={false} src={src} />
      )
    } else if (fileType === 'audio') {
      previewItem = <video key={name + 'file-audio-preview'} controls={true}  src={src} />
    } else if (fileType === 'image') {
      previewItem = <img key={name + 'file-image-preview'} src={src} alt="" />
    } else {
      previewItem = <img key={name + 'file-image-preview'}  src={src} alt="" />
    }

    setFilePreviewItem(previewItem)
  }, [value, name])
  return (
    <InputWrapper>
      {label && <InputLabel>{label}</InputLabel>}
      <InputUpload
        id={id}
        name={name}
        type="file"
        onChange={(e: any) => {
          const input = e.currentTarget
          setFieldValue({ file: input.files[0], fakePath: input.value })
        }}
        accept={accept}
        validate={validate}
        value={value ? value.fakePath : ''}
      />
      <div className={errorMessage ? 'upload error' : 'upload'}>
        {value ? (
          <div className="upload-preview">
            <div
              className="remove-upload"
              onClick={() => {
                if (removeFile) {
                  removeFile()
                } else {
                  setFieldValue(null)
                }
              }}
            >
              X
            </div>
            {filePreviewItem}
          </div>
        ) : (
          <div className="upload-item-wrapper">
            <div className="upload-description">{description}</div>
            <NFTButton className="upload-button" onClick={()=> {
              const input = document.getElementById(id) as HTMLInputElement
              input.click()
            }}>Choose file</NFTButton>
            {/* <label className="upload-button" htmlFor={id}>
              Choose file
            </label> */}
          </div>
        )}
      </div>
      {errorMessage && <InputError>{errorMessage}</InputError>}
    </InputWrapper>
  )
}
